var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg129Joke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.628,324.38,0,256,0S123.333,26.628,74.981,74.98S0,187.62,0,256s26.629,132.667,74.981,181.019 S187.62,512,256,512c46.81,0,92.615-12.757,132.461-36.893c9.448-5.722,12.468-18.02,6.745-27.468 c-5.723-9.448-18.024-12.469-27.468-6.745C334.141,461.244,295.502,472,256,472c-119.103,0-216-96.897-216-216S136.897,40,256,40 s216,96.897,216,216c0,42.588-12.665,84.044-36.627,119.885c-6.138,9.182-3.671,21.603,5.512,27.742 c9.184,6.14,21.602,3.671,27.742-5.511C497.002,355.672,512,306.53,512,256C512,187.62,485.371,123.332,437.02,74.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,191c5.514,0,10,4.486,10,10c0,11.046,8.954,20,20,20s20-8.954,20-20c0-27.57-22.43-50-50-50s-50,22.43-50,50 c0,11.046,8.954,20,20,20s20-8.954,20-20C158,195.485,162.487,191,168,191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,281.943c-6.34,0-11.981,2.959-15.646,7.562C322.081,293.094,298.667,317,256,317 c-43.361,0-66.669-24.492-69.431-27.573c-3.666-4.558-9.282-7.482-15.587-7.482c-11.047,0-20.003,8.956-20.003,20.003 c0,4.858,1.735,9.31,4.615,12.775l-0.016,0.013c0.91,1.101,13.133,17.994,39.973,30.085l0.508,34.074 c0.488,32.777,27.309,59.106,59.98,59.106c0.302,0,0.604-0.002,0.907-0.007c33.08-0.493,59.592-27.807,59.099-60.915 l-0.521-32.073c27.129-12.087,39.937-29.115,40.855-30.22l-0.027-0.023c2.902-3.472,4.652-7.939,4.652-12.817 C361.004,290.899,352.048,281.943,341,281.943z M270.403,391.93c-3.721,3.833-8.711,5.988-14.053,6.068 c-10.981,0.146-20.133-8.673-20.296-19.7l-0.335-22.502C242.059,356.569,248.814,357,256,357c6.954,0,13.516-0.417,19.695-1.167 l0.354,21.869C276.13,383.044,274.124,388.097,270.403,391.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,201c0-11.046-8.954-20-20-20h-60c-11.046,0-20,8.954-20,20s8.954,20,20,20h60C386.046,221,395,212.045,395,201z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg129Joke);
export default __webpack_public_path__ + "static/media/129-joke.31c7afeb95cd64266c2305591251a170.svg";
export { ForwardRef as ReactComponent };